<template>
    <div>
        <!-- MAIN IMAGE -->
        <!-- <section>
            <v-layout column align-center justify-center class="white--text">
                <img src="../assets/img/oblo/reception_fix.jpg" alt="" style="object-fit: cover" height="600px" width="100%">
            </v-layout>
        </section> -->

        <section>
            <v-layout row wrap>
                <v-flex xs12>
                <v-card class="elevation-0 transparent">
                    <v-card-title primary-title class="layout justify-center">
                    <span class="display-2">{{$t("home.contact")}}</span>
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                        <p class="sub-intro">
                            {{$t("home.contact_details")}}
                        </p>
                        
                        <p class="sub-intro">
                            <v-icon class="success--text text--lighten-2">phone</v-icon>
                            +39 3490699160
                            <v-icon class="success--text text--lighten-2 ml-5">phone</v-icon>
                            +39 3460652050
                        </p>

                        <p class="sub-intro">
                            <v-icon class="success--text text--lighten-2">place</v-icon>
                            Piazza dei Martiri 3, 95131 Catania
                        </p>

                        <p class="sub-intro">
                            <v-icon class="success--text text--lighten-2">email</v-icon>
                            info@oblobb.it
                        </p>
                    </v-card-text>
                </v-card>
                </v-flex>
            </v-layout>
        </section>

        <!-- MAP -->
        <section>
            <v-layout row align-center justify-center class="my-0">
                <oblo-map style="heigth: 350px; width: 2000px;"/>
            </v-layout>
        </section>

        <section>
            <v-layout row wrap align-center>
                <v-flex xs12 sm12 md12 lg12 text-xs-center class="pa-5">
                    <p class="display-2">{{$t("contact.title")}}</p>
                    <p class="sub-intro">
                        {{$t("contact.sub-title")}}
                    </p>

                    <p class="sub-intro px-5">
                        <v-icon large class="success--text text--lighten-2 mr-4">fas fa-plane</v-icon>
                        {{$t("contact.aeroplane")}}
                    </p>
                    <p class="sub-intro px-5">
                        <v-icon large class="success--text text--lighten-2 mr-4">fas fa-bus</v-icon>
                        {{$t("contact.bus")}}
                    </p>
                    <p class="sub-intro px-5">
                        <v-icon large class="success--text text--lighten-2 mr-4">fas fa-subway</v-icon>
                        {{$t("contact.train")}}
                    </p>
                    <p class="sub-intro px-5">
                        <v-icon large class="success--text text--lighten-2 mr-4">fas fa-ship</v-icon>
                        {{$t("contact.ship")}}
                    </p>
                </v-flex>

                <v-flex xs12 sm12 md12 lg12 text-xs-center class="pa-5">
                    <p class="sub-intro px-5">
                        <v-icon large class="success--text text--lighten-2 mr-4">fas fa-car</v-icon>
                        {{$t("contact.car")}}
                    </p>
                    <p class="sub-intro px-5">
                        {{$t("contact.palermo")}}
                    </p>
                    <p class="sub-intro px-5">
                        {{$t("contact.siracusa")}}
                    </p>
                    <p class="sub-intro px-5">
                        {{$t("contact.messina")}}
                    </p>
                </v-flex>
            </v-layout>
        </section>
    </div>
</template>

<script>
import ObloMap from './ObloMap.vue';

export default {
    components: { ObloMap }
}
</script>


<style scoped>
    .sub-intro{
        font-size: large;
        font-weight: 400;
    }
</style>
